export let BrazeMarketingChannelType;

(function (BrazeMarketingChannelType) {
  BrazeMarketingChannelType["InboxNotification"] = "inbox-notification";
  BrazeMarketingChannelType["InboxMessage"] = "inbox-message";
  BrazeMarketingChannelType["PromoBox"] = "promobox";
  BrazeMarketingChannelType["InAppMessage"] = "in-app-message";
})(BrazeMarketingChannelType || (BrazeMarketingChannelType = {}));

export const brazeChannels = Object.values(BrazeMarketingChannelType);
export const PROMO_BOX_PAGE_LENGTH = 20;
export const PROMO_BOX_INDEX_IN_FEED_ROW = 3;
export const IN_APP_MAX_BUTTONS_COUNT = 2; // In Braze dashboard, you are able to to choose between "Modal" and "Full Screen Modal" type

export let FullScreenInAppStyle;

(function (FullScreenInAppStyle) {
  FullScreenInAppStyle["Cover"] = "cover";
  FullScreenInAppStyle["Splash"] = "splash";
})(FullScreenInAppStyle || (FullScreenInAppStyle = {}));

export let BrazeCustomEvent; // deferred events are events that should be triggered after user has been navigated to another page

(function (BrazeCustomEvent) {
  BrazeCustomEvent["RegistrationCompleted"] = "registration_completed";
  BrazeCustomEvent["ListingCreated"] = "listing_created";
  BrazeCustomEvent["EscrowPurchaseCompleted"] = "escrow_purchase_completed";
  BrazeCustomEvent["MarkedAsSold"] = "marked_as_sold";
  BrazeCustomEvent["ConfirmedEmail"] = "confirmed_email";
  BrazeCustomEvent["FirstAppViewAfterOnboarding"] = "first_app_view_after_onboarding";
})(BrazeCustomEvent || (BrazeCustomEvent = {}));

export const CONFIRMED_EMAIL_COOKIE_KEY = 'braze_confirmed_email';
export const MARKED_AS_SOLD_COOKIE_KEY = 'braze_marked_as_sold';
export const BRAZE_EVENTS_WITH_PROPERTIES = [BrazeCustomEvent.ListingCreated, BrazeCustomEvent.EscrowPurchaseCompleted, BrazeCustomEvent.MarkedAsSold];